// contexts/User/index.jsx
import React, { useEffect, useCallback, createContext, useState } from 'react';
import { LOGIN, REAL_USER } from 'store/actions';
import { useDispatch } from 'react-redux';

export const UserContext = createContext();

// 1.	安装 Redux Toolkit & React-Redux
// 2.	定义 Slice（包含 state + reducer + actions）
// 3.	创建 Store（集中管理所有 slice）
// 4.	用 Provider 注入 Store（让 React 全局能访问 Redux）
// 5.	组件里用 useSelector 取值，用 useDispatch 改值

// eslint-disable-next-line
const UserProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  const loadUser = useCallback(() => {
    let user = localStorage.getItem('user');
    let realUser = localStorage.getItem('realUser');
    if (user) {
      let data = JSON.parse(user);
      dispatch({ type: LOGIN, payload: data });

      if(realUser){
        let realData = JSON.parse(realUser);
        const impersonate = realUser && data?.id !== realData.id;
        // 切换了账户
        if(impersonate){
          dispatch({ type: REAL_USER, payload: realData });
        }
      }

    }
    setIsUserLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return <UserContext.Provider value={{ loadUser, isUserLoaded }}> {children} </UserContext.Provider>;
};

export default UserProvider;
